// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_of-0";